import { useCallback } from 'react'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_CREATE_API_KEY_SERVER } from '@/app/module/user/definitions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useCreateAuthToken = () => {
  const dispatch = useAppDispatch()
  const [mutate, res] = esApi.useCreateUserAuthTokenMutation()

  const createToken = useCallback(async () => {
    try {
      await mutate().unwrap()
      return true
    } catch (e) {
      dispatch(
        createNotification({
          'create-api-key-error': {
            type: 'error',
            message: getErrorMessage(e, ERROR_CREATE_API_KEY_SERVER),
          },
        }),
      )
      return false
    }
  }, [mutate, dispatch])

  return [createToken, res] as const
}
